import CatalogSettings from './CatalogSettings';

export default CatalogSettings;
